import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { logoutUser } from '../actions';

import '../stylesheets/navigation-bar.css'

class NavigationBar extends Component {
    constructor(props){
      super(props);
      this.state={
        showPopUp:false
      }
    }  
  
    getUserDetails(){
      let user = null;
      if(this.props.user){
        const {email,name,pic} = this.props.user;
        user = {email,name,pic};
      }
      return user;
    }
    logout(){
      this.props.logoutUser();
      this.setState({showPopUp:false});
    }
    popUp(){
      let user = this.getUserDetails();
      return(
          <div className='pop-up-box'>
            <div onClick={()=>this.setState({showPopUp:false})} style={{float:'right'}}><i className='fa fa-times'></i></div>
            <div style={{fontWeight:'bold'}}>
              {user.name}
            </div>
            <div>
              <small>{user.email}</small>
            </div>
            <hr/>
              <div className='' style={{float:'right'}}>
              <button onClick={()=>this.logout()}className='btn btn-danger sign-out-btn-nav'>Sign Out</button> 
            </div> 
          </div>
      )
    }
    render(){
      let user = this.getUserDetails();
      //console.log(user);
      return(
          <header>
          <nav className="navbar navbar-expand-lg navbar-light">
        <a className="navbar-brand">React Mini Projects</a>
        <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav mr-auto">
            <li className="nav-item">
              <Link to='/' className='nav-link' >Home</Link>
            </li> 
            <li className="nav-item dropdown">
              <a className="nav-link dropdown-toggle"  id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                Time
              </a>
              <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                <a className="dropdown-item"  href="/time/countdown">Countdown</a>
                <a className="dropdown-item"  href="/time/stopwatch">Stopwatch</a>
                <a className="dropdown-item"  href="/time/timer">Timer</a>
              </div>
            </li>
            <li>
            <Link to='/reminder'  className='nav-link'>Reminder</Link>
            </li>
            <li>
            <Link to='/goal'  className='nav-link'>Goal</Link>
            </li>

          </ul>
        </div>
        <div className="navbar-collapse collapse  order-3 dual-collapse2">
        <ul className="navbar-nav ml-auto">
           <li className="nav-item" >
                <div 
                style={{width:'20%',float:'right'}}
                onClick={()=>{
                  let bool = !this.state.showPopUp;
                  this.setState({showPopUp:bool})
                }}
                >
                {
                  user /*&& user.pic!==undefined*/ ?
                  <img alt='Profile pic' style={{width:'100%',height:'100%',objectFit:'contain'}} src={user.pic}/> :
                  null
                }
                </div>
            </li>
        </ul>
    </div>
      </nav>
      {this.state.showPopUp?this.popUp():null}
      </header>)
    }
}

function mapStateToProps(state){
  return state;
}

export default connect(mapStateToProps,{logoutUser})(NavigationBar);


// WEBPACK FOOTER //
// ./src/components/NavigationBar.jsx